import classes from './App.module.css';
import { useSelector, useDispatch } from "react-redux";
import { authActions } from "./store/auth-Slice";
import React, { useEffect, useState } from "react";
import { createBrowserRouter, RouterProvider, useNavigate, useParams } from "react-router-dom";
import RootLayout from "./Pages/Root/Root/AuthRootLayout";
import SubRootLayout from './Pages/Root/SubRoot/SubRootLayout';
import SearchView, { loader, loader as SearchViewLoader } from "./Pages/SearchView/SearchView";
import AllSites, { loader as DashboardLoader } from './Pages/AllSites/allSites';
import Dashboard from './Pages/Dashboard/Dashboard'
import SiteView, { loader as siteviewLoader } from "./components/Site/Device/SiteView";
import ErrorPage from "./Pages/Error/ErrorPage";
import VerifyPage from "./components/LoggingIn/VerifyAccount/VerifyPage";
import LoginPage from './components/LoggingIn/LoginV2/LoginPage';
import PortalActivityPage, { loader as portalActivityLoader } from './Pages/PortalActivity/PortalActivityPage';
import UserManagementPage, { loader as userManagementPageLoader } from './Pages/User Management/UserManagementPageTableView';
import { uiActions } from './store/ui-slice';
import UserDevicesPage, { loader as userDevicesPageLoader } from './Pages/User Devices/UserDevicesPage';
import UserManagementRoot from './Pages/User Management/UserManagementRoot';
import RegisterPage from './components/LoggingIn/Register/RegisterPage';
import FullRegistration from './components/UI/Cards/FormCard/FullRegistration';
import Padlocks from './Pages/Padlocks/padlocks';
import Sensors from './Pages/Sensors/sensors';
import Gateways from './Pages/Gateways/gateways'
import Keyboxes from './Pages/Keyboxes/keyboxes';
import OfflineSites from './Pages/OfflineSites/offlineSites';
import Controllers from './Pages/Controllers/Controllers';
import UserManagementPageCardGrid from './Pages/User Management/UserManagementPageCardGrid';
import { tokenLoader, checkAuthLoader } from "./auth";
import { loader as logoutAction } from "./Pages/Logout/Logout";
import DeviceActivityPage, {loader as deviceActivityPageLoader} from './Pages/DeviceActivity/DeviceActivityPage';
import Groups, {loader as groupsLoader} from './Pages/Groups/Groups';
import GroupSites, {loader as GroupSitesLoader} from './Pages/Groups/GroupSites';
import GroupUsers from './Pages/Groups/GroupUsers';
import ResetPin from './ResetPin/resetPin'
import CreatePin from './CreatePin/createPin';
import ResetSuccess from './ResetPin/resetSuccess'
import CreateSuccess from './CreatePin/createSuccess';
import CreateAccount from './Register/register'
import RegisterSuccess from './Register/registerSuccess'
import FullAccountRegistration from './Register/fullAccountRegistration'
import { socket } from './Socket/socket';
import DataManager from './hooks/DataManager';
import { elements } from 'chart.js';
import UpdateBanner from './VersionControl/UpdateBanner';
import ResetPortalPassword from './components/LoggingIn/ResetPassword/ResetPortalPassword';
import PortalPasswordResetSuccess from './components/LoggingIn/ResetPassword/PortalPasswordResetSuccess';
import RuleReducer, { RuleProvider } from './components/UI/Cards/Automations/CreateRuleNew/RuleReducer'
import InactiveSites from './Pages/InactiveSites/inactiveSites';
import { PrimeReactProvider } from 'primereact/api';
import { Dialog } from 'primereact/dialog';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import SitesOnSchedule from './Pages/SitesOnSchedule/sitesOnSchedule';
import ActiveSites from './Pages/ActiveSites/activeSites';
import CCTVIntegrations from './Pages/CCTVIntegrations/CCTVIntegrations';
import PadlockEntity, { padlockLoader } from './Pages/Padlocks/padlockEntity';
import ScheduledAction from './components/UI/Cards/Automations/EditAutomations/ScheduledAction';
import ScheduledActionsSites from './Pages/HolidayMode/scheduledActions';
import LiveViewSites from './Pages/LiveViewSites/liveViewSites';
import SiteCameras, { camerasLoader } from './Pages/LiveViewSites/siteCameras';
import autoLogout from './hooks/autoLogout';
import useAutoLogout from './hooks/autoLogout';
import mixpanel from 'mixpanel-browser';
import GatewayEntity, { gatewayLoader } from './Pages/Gateways/gatewayEntity';
import SensorEntity, { sensorLoader } from './Pages/Sensors/sensorEntity';

import Lottie from 'lottie-react';
import { Button } from 'primereact/button';
import failAnim from './assets/animations/fail.json'
import TankSensors from './Pages/TankSensors/tankSensors';
import TankSensorEntity from './Pages/TankSensors/tankSensorEntity';


const dataManager = new DataManager();

const KeyedSiteView = () => {
    const { SiteID } = useParams();
    return <SiteView key={SiteID} />;
};

const AuthRoute = {

  path: '/',
  element: <RootLayout/>,
  errorElement: <ErrorPage/>,
  loader: tokenLoader,
  children: [
    {
      index: true,
      element: <LoginPage/>
    },
    {
      path: 'Verify',
      element: <VerifyPage/>,
    },
    {
      path: 'Register',
      element: <RegisterPage />
    },
    {
      path: 'FullRegistration',
      element: <FullRegistration />
    },
    {
      path: '/Dashboard',  // <-- changed from /AllSites
      element: <SubRootLayout />,
      loader: checkAuthLoader,
      children: [
        {
          index: true,
          element: <Dashboard />  // <-- now the default landing page
        },
        {
          path: 'AllSites',
          element: <AllSites />,
          loader: DashboardLoader
        },
        {
          path: 'SearchView',
          element: <SearchView />,
          loader: SearchViewLoader
        },
        {
          path: 'SiteView/:SiteID',
          element: <KeyedSiteView />,
          loader: siteviewLoader
        },
        {
          path: 'Users',
          element: <UserManagementRoot />,
          children: [
            {
              index: true,
              element: <UserManagementPageCardGrid />,
              loader: userManagementPageLoader
            },
            {
              path: 'UserSites',
              element: <UserDevicesPage />,
              loader: userDevicesPageLoader
            },
          ]
        },
        {
          path: 'Offline',
          element: <OfflineSites/>
        },
        {
          path: 'TemporarySchedules',
          element: <SitesOnSchedule/>
        },
        {
          path: 'ScheduledActions',
          element: <ScheduledActionsSites/>
        },
        {
          path: 'Controllers',
          element: <Controllers/>
        },
        {
          path: 'ActiveSites',
          element: <ActiveSites/>
        },
        {
          path: 'InactiveSites',
          element: <InactiveSites/>
        },
        {
          path: 'CCTVIntegrations',
          element: <CCTVIntegrations/>
        },
        

        {
          path: 'LiveViewSites',
          element: <UserManagementRoot />,
          children: [
            {
              index: true,
              element: <LiveViewSites />
            },
            {
              path: 'Site/:SiteUUID',
              element: <SiteCameras/>,
              loader: camerasLoader
            }
          ]
        },

        {
          path: 'Activity',
          element: <PortalActivityPage />,
          loader: portalActivityLoader
        },
        {
          path: 'SiteActivity',
          element: <DeviceActivityPage />,
          loader: deviceActivityPageLoader
        },
        {
          path: 'Groups',
          element: <UserManagementRoot />,
          children: [
            {
              index: true,
              element: <Groups />,
              loader: groupsLoader,
            },
            {
              path: 'GroupSites',
              element: <GroupSites />,
              children: [
                {
                  path: 'GroupUsers',
                  element: <GroupUsers />,
                },
              ],
            },
          ],
        },
        {
          path: 'Padlocks',
          element: <UserManagementRoot />,
          children: [
            {
              index: true,
              element: <Padlocks />
            },
            {
              path: 'Lock/:LockID',
              element: <PadlockEntity/>,
              loader: padlockLoader
            }
          ]
        },
        {
          path: 'Keyboxes',
          element: <Keyboxes />
        },
        {
          path: 'Sensors',
          element: <UserManagementRoot />,
          children: [
            {
              index: true,
              element: <Sensors />
            },
            {
              path: 'Sensor/:SensorID',
              element: <SensorEntity />,
              loader: sensorLoader
            }
          ]
        },
        {
          path: 'TankSensors',
          element: <UserManagementRoot />,
          children: [
            {
              index: true,
              element: <TankSensors />
            },
            {
              path: 'Sensor/:SensorID',
              element: <TankSensorEntity/>,
              loader: sensorLoader
            }
          ]
        },
        {
          path: 'Gateways',
          element: <UserManagementRoot />,
          children: [
            {
              index: true,
              element: <Gateways />
            },
            {
              path: 'Gateway/:GatewayIMEI',
              element: <GatewayEntity/>,
              loader: gatewayLoader
            }
          ]
        },
        
      ]
    },
    {
      path: '/logout',
      loader: logoutAction
    },
    {
      path: "/ResetPin",
      element: <ResetPin />,
    },
    {
      path: "/ResetSuccess",
      element: <ResetSuccess />,
    },
     {
      path: "/CreatePin",
      element: <CreatePin />,
    },
    {
      path: "/CreateSuccess",
      element: <CreateSuccess />,
    },
    {
      path: "/CreateAccount",
      element: <CreateAccount />,
    },
    {
      path: "/RegisterSuccess",
      element: <RegisterSuccess />,
    },
    {
      path: "/CreateAdminAccount",
      element: <FullAccountRegistration />,
    },
    {
      path: "/resetPortalPassword", 
      element: <ResetPortalPassword/>
    },
    {
      path: "/resetPortalPasswordSuccess",
      element: <PortalPasswordResetSuccess/>
    }
  ],
}

const router = createBrowserRouter([
  AuthRoute
]);

const App = (props) => {
  const [isConnected, setIsConnected] = useState(socket.connected);
  const [pinStates, setPinStates] = useState([]);
  const [versionNumber, setVersionNumber] = useState(sessionStorage.getItem('versionNumber') || "1.0.0")
  const [visible, setVisible] = useState(false)
  const [errorNotification, setErrorNotification] = useState({ visible: false, message: '' })
  const [detailledErrorNotification, setDetailledErrorNotification] = useState({visible: false, detailledMessage: '', succeededCount: 0, failedCount: 0, failed: [], succeeded: [], hub: ""})

  sessionStorage.setItem('versionNumber', versionNumber)


  useAutoLogout({
  timeout: 720 * 60000,
  onLogout: () => {
    localStorage.clear();
    window.location.href = '/logout'; // full page redirect
  },
});

  useEffect(() => {
    function onConnect() {
      setIsConnected(true);
    }

    function onDisconnect() {
      setIsConnected(false);
    }

    function onPinStatesChange(value) {
      if (value['uuid'] == "98838ee4-f84e-4af7-a704-a9ed3c42ff8c") {
        setPinStates(value)
      }
      if (dataManager.getItem('deviceUUIDs').includes(value['uuid'])){
        setPinStates(value);
      }
    }

    function onPortalVersionChange(newVersion) {
      setVersionNumber(newVersion)
      const oldNumber = sessionStorage.getItem('versionNumber')
      if (oldNumber !== newVersion){
          setVisible(true)
          sessionStorage.setItem('versionNumber', newVersion)
      }
    }

    function onAppErrorNotification(value) {

      console.log(value.message);
      const currentDeviceUUID = localStorage.getItem('DeviceUUID');
      if (currentDeviceUUID && value.deviceUuid === currentDeviceUUID) {
        const msg = value.message.toLowerCase();
        //const details = value.details ?? null
        const newMessageAction = msg.includes("disarming") ? "disarming" : "arming";

        const typeMap = {
          ajax: "AJAX",
          hikvision: "Hikvision",
          dahua: "Dahua",
          camect: "Camect"
        };

        let succeededCount = 0
        let failedCount = 0
        let hub = ""
        let passes = []
        let failed = []
        let detailledMessage = ""

       

        // if (details != null) {
        //   detailledMessage = msg
        //   succeededCount = details.succeededCount
        //   failedCount = details.failedCount
        //   hub = details.hub
        //   passes = details.succeeded
        //   failed = details.failed
        // }

        const matchedTypeKey = Object.keys(typeMap).find(key => msg.includes(key));
        const newMessageType = matchedTypeKey ? typeMap[matchedTypeKey] : "";

        const newMessageReason = msg.includes("offline")
          ? "- device may be offline"
          : "";

        const newMessage = `Error ${newMessageAction} ${newMessageType} ${newMessageReason}`.replace(/\s+/g, " ").trim();

       // if (details != null) {
          //setDetailledErrorNotification({visible: true, detailledMessage: detailledMessage, succeededCount: succeededCount, failedCount: failedCount, failed: failed, succeeded: passes, hub: hub})
        //} else {
          setErrorNotification({ visible: true, message: newMessage });
      //  }
      }
    }

    // const handleBeforeUnload = (e) => {
    //   // If you want to trigger only when user is logged in:
    //   const token = localStorage.getItem("token");
    //   if (!token) return;

    //   e.preventDefault();
    //   e.returnValue = ""; // Required for Chrome
    // };

    //window.addEventListener("beforeunload", handleBeforeUnload);

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    socket.on('appPinStates', onPinStatesChange);
    socket.on('portalVersionNumber', onPortalVersionChange);
    socket.on('appErrorNotification', onAppErrorNotification);

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      socket.off('appPinStates', onPinStatesChange);
      socket.off('portalVersionNumber', onPortalVersionChange);
      socket.off('appErrorNotification', onAppErrorNotification);

      // window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);


  const token = useSelector(state => state.auth.token);
  const refreshToken = useSelector(state => state.auth.refreshToken);
  const dispatch = useDispatch();

  return (
    <React.Fragment>
      <UpdateBanner visible={visible} setVisible={setVisible}/>

      {/* Wrap RouterProvider with RuleProvider */}
      <PrimeReactProvider>


        <Dialog
          header="Site notification"
          visible={errorNotification.visible}
          style={{ width: 'clamp(300px, 40vw, 520px)' }}
          onHide={() => setErrorNotification({ visible: false, message: '' })}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            
            <h3 style={{ color: '#6e6e6e', fontSize: '18px', margin: 0 }}>Something went wrong</h3>
            <br/>
            <Lottie
                animationData={failAnim}
                loop={false}
                style={{ width: 150, height: 150, margin: "0px" }}
            />
            <br/>
            <h3 style={{ color: "#6e6e6eff", fontSize: '16px', textAlign:"center" }}>{errorNotification.message}</h3>
            
            <br/>
            <Button label="Close" icon="pi pi-times" rounded severity="secondary" onClick={() => setErrorNotification({visible: false, message: ''})}/>
            </div>
          </Dialog>

        <Dialog
          header="Site notification"
          visible={detailledErrorNotification.visible}
          style={{ width: 'clamp(300px, 40vw, 520px)' }}
          onHide={() => setErrorNotification({ visible: false, message: '' })}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            
            <h3 style={{ color: '#6e6e6e', fontSize: '18px', margin: 0 }}>{detailledErrorNotification.detailledMessage}</h3>
            <br/>
            <Lottie
                animationData={failAnim}
                loop={false}
                style={{ width: 150, height: 150, margin: "0px" }}
            />
            <br/>
            <h3 style={{ color: "#6e6e6eff", fontSize: '16px', textAlign:"center" }}>{`${detailledErrorNotification.succeededCount} channels succeeded`}</h3>
            <h3 style={{ color: "#6e6e6eff", fontSize: '16px', textAlign:"center" }}>{`${detailledErrorNotification.failedCount} channels failed`}</h3>

            {(detailledErrorNotification.failed.length > 0 || detailledErrorNotification.succeeded.length > 0) && (
              <div style={{ width: '100%', maxHeight: 260, overflowY: 'auto' }}>
                {detailledErrorNotification.failed.map((item, index) => (
                  <div
                    key={`failed-${item.channel}-${index}`}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 8,
                      padding: '8px 10px',
                      marginBottom: 6,
                      borderRadius: 6,
                      backgroundColor: '#fdecea',
                    }}
                  >
                    <i className="pi pi-times-circle" style={{ color: '#d32f2f', marginTop: 2 }} />
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 600, color: '#6e6e6e' }}>
                        {`Channel ${item.humanChannel} (${item.eventType})`}
                      </div>
                      <div style={{ fontSize: 13, color: '#6e6e6e' }}>{item.error}</div>
                      {item.rawResponse && (
                        <div style={{ fontSize: 12, color: '#9e9e9e' }}>{item.rawResponse}</div>
                      )}
                    </div>
                  </div>
                ))}

                {detailledErrorNotification.succeeded.map((item, index) => (
                  <div
                    key={`succeeded-${item.channel}-${index}`}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 8,
                      padding: '8px 10px',
                      marginBottom: 6,
                      borderRadius: 6,
                      backgroundColor: '#eaf6ec',
                    }}
                  >
                    <i className="pi pi-check-circle" style={{ color: '#2e7d32', marginTop: 2 }} />
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 600, color: '#6e6e6e' }}>
                        {`Channel ${item.humanChannel} (${item.eventType})`}
                      </div>
                      {item.rawResponse && (
                        <div style={{ fontSize: 12, color: '#9e9e9e' }}>{item.rawResponse}</div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
            <br/>
            <Button label="Close" icon="pi pi-times" rounded severity="secondary" onClick={() => setDetailledErrorNotification({ visible: false, detailledMessage: '', succeededCount: 0, failedCount: 0, failed: [], succeeded: [], hub: ""})}/>
            </div>
          </Dialog>


        <RuleProvider>
          <RouterProvider router={router} />
        </RuleProvider>
      </PrimeReactProvider>
    </React.Fragment>
  );
}

export default App;


